module.exports = __webpack_public_path__ + "Roboto-Black.ab04c7611d94b690aee3.svg";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Black.svg
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Black.svg
// module chunks = styles